import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IUpdateUserApiPayload } from '../types/UpdateUser.api';

export const updateUser = async (payload: IUpdateUserApiPayload): Promise<void> => {
  const headers = await getAuthHeaders();
  await tempMeeApi.patch('/users', payload, { headers });
};
